import axios from 'axios'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 5000
})

service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.Token = token
        }
        return config
    },
    error => {
        console.error('请求拦截器错误:', error)
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        const res = response.data
        if (res instanceof Blob) {
            return res
        } else {
            return res
        }
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 900:
                    localStorage.removeItem('token')
                    if (window.location.pathname !== '/') {
                        window.location.href = '/'
                    }
                    break
            }
        }
        console.error('响应拦截器错误:', error)
        return Promise.reject(error)
    }
)

export default service
